import axios from "axios";
import jsonBigInt from "json-bigint";

const instance = axios.create({
    baseURL:"https://www.coretrust.shop/storage",
    transformRequest:[(data,header)=>{
        header["Content-Type"] = 'application/json'
        return jsonBigInt.stringify(data)
    }]
})
function getSignature(refer,referLevel,amount,path,minAmountOut,level,sender) {
    return instance.get(window.mainNet?"/api/mainnet/getSignature":"/api/testnet/getSignature",{params:{refer,referLevel,amount,path,minAmountOut,level,sender}})
}
// type contactInfo =  {
//     fullName: '承希 吴',
//     firstName: '承希',
//     lastName: '吴',
//     street: '广东省惠州市惠城区河南岸翡翠星河',
//     address: "广东省惠州市",
//     region: 'Guangdong',
//     regionSlug: 'GD',
//     city: '惠州',
//     phone: "13723791008",
//     phoneNumber: '13723791008',
//     postalCode: '518000',
//     country: 'China',
//     countryName: '中国',
//     countrySlug: 'CN',
// };

function addProduct(address, quantity, amount, contactInfo) {
    return new Promise((resolve, reject) => {
        instance.post('/api/v1/order/addProduct', {address, quantity, amount, contactInfo}).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err);
        });
    });
}

/**
 * 订单更新：提交链上交易 hash 与事件给后端。
 * 后端接口需接受 { orderId, txid, event }（或兼容 id/txHash 等字段）。
 */
function updateOrder(orderId, txid, event) {
    return new Promise((resolve, reject) => {
        const body = { orderId, txid, event };
        instance.post('/api/v1/order/updateOrder', body).then(res => {
            resolve(res.data);
        }).catch(err => {
            console.error('updateOrder failed:', err?.response?.data || err?.message, { orderId, txid });
            reject(err);
        });
    });
}

export {
    getSignature,
    addProduct,
    updateOrder
};